import { InsuranceId, ProductType, ProductInfo } from "./types";

// 通用旅行保险（酒店/线路/导游用）
export const travelInsurancePlans = [
  {
    id: "none" as InsuranceId,
    name: "不购买",
    price: 0,
    desc: "不添加保险保障",
    icon: "ri-close-circle-line",
    color: "#9CA3AF",
  },
  {
    id: "basic" as InsuranceId,
    name: "基础保障",
    price: 28,
    desc: "意外伤害 10万 + 医疗 3万",
    icon: "ri-shield-line",
    color: "#10B981",
  },
  {
    id: "standard" as InsuranceId,
    name: "标准保障",
    price: 58,
    desc: "意外伤害 50万 + 医疗 10万 + 取消险",
    icon: "ri-shield-check-line",
    color: "#FF6B35",
  },
  {
    id: "premium" as InsuranceId,
    name: "全面保障",
    price: 98,
    desc: "意外伤害 100万 + 医疗 20万 + 取消险 + 行李险",
    icon: "ri-shield-star-line",
    color: "#8B5CF6",
  },
];

// 产品信息
export const productInfoMap: Record<ProductType, ProductInfo> = {
  hotel: {
    icon: "🏨",
    name: "三亚海景度假酒店",
    detail: "豪华海景大床房 · 2025-05-01 入住 ~ 05-05 离店",
    spec: "含早餐 · 4晚",
    price: 2999,
    image: "https://readdy.ai/api/search-image?query=luxury%20five%20star%20beachfront%20resort%20hotel%20sanya%20yalong%20bay%20infinity%20pool%20tropical%20ocean%20view%20palm%20trees%20golden%20hour&width=112&height=112&seq=of_hotel&orientation=squarish",
  },
  car: {
    icon: "🚗",
    name: "别克GL8 商务舱",
    detail: "取车：三亚凤凰机场",
    spec: "4天 · 全险 · 含司机",
    price: 588,
    image: "https://readdy.ai/api/search-image?query=Buick%20GL8%20luxury%20MPV%20white%20clean%20professional%20car%20photography%20side%20view&width=112&height=112&seq=of_car&orientation=squarish",
  },
  route: {
    icon: "🗺️",
    name: "三亚5日深度游",
    detail: "出行：2025-05-20 ~ 05-25",
    spec: "5天4晚 · 含门票 · 含导游",
    price: 1999,
    image: "https://readdy.ai/api/search-image?query=Sanya%20Wuzhizhou%20Island%20crystal%20clear%20turquoise%20water%20aerial%20view%20snorkeling&width=112&height=112&seq=of_route&orientation=squarish",
  },
  guide: {
    icon: "👩‍✈️",
    name: "当地专业导游",
    detail: "服务：2025-05-01 ~ 05-03",
    spec: "3天 · 普通话/英语",
    price: 1288,
    image: "https://readdy.ai/api/search-image?query=professional%20female%20tour%20guide%20sanya%20portrait%20smiling%20confident%20tropical%20beach%20background&width=112&height=112&seq=of_guide&orientation=squarish",
  },
};

// 租车天数
export const CAR_DAYS = 4;
